/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Vietnamese (Vietnam)
export default {
  'fabric.editor.chromeCollapsedPlaceholder': 'Nhập nội dung bất kỳ...',
  'fabric.editor.editorAssistiveLabel': 'Vùng nội dung chính, bắt đầu gõ để nhập văn bản.',
  'fabric.editor.headingLink.toolbarHelpTitle': 'Mở hộp thoại trợ giúp'
};